var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseEditableCard,{staticClass:"early__release",attrs:{"title":"Досрочки","is-show-edit-buttons":false,"is-transparent":""}},[_c(_setup.BaseTable,{staticClass:"early__release-table",attrs:{"headers":_setup.headers,"items":_setup.formattedItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }